import { Component, OnInit } from '@angular/core';
import { WebWidgetService } from "../web-widget/web-widget.service";

@Component({
  selector: 'cc-click-to-call-button',
  templateUrl: './click-to-call-button.component.html',
  styleUrls: ['./click-to-call-button.component.scss']
})
export class ClickToCallButtonComponent implements OnInit {

  constructor(public webWidgetService: WebWidgetService) { }

  ngOnInit() {
  }

  openWidget() {
    this.webWidgetService.openDialPad();
  }

}
